import { TreatmentPlanTemplateStoreData } from "@/modules/patients/services/fetchTreatmentPlanTemplates"
import { AsyncRequestStatus } from "@/types/__generated__/union-types"

export const matchesAsyncRequestStatus = (
  usage: TreatmentPlanTemplateStoreData["asynchronousQuestionnaireUsage"],
  asyncRequestStatus: AsyncRequestStatus | null,
  isAsyncPrescription: boolean,
): boolean => {
  if (!isAsyncPrescription) return usage === null
  if (asyncRequestStatus === null) return usage !== null
  if (usage === "ALL") return asyncRequestStatus === "APPROVED" || asyncRequestStatus === "REJECTED"
  if (usage === "ACCEPTED") return asyncRequestStatus === "APPROVED"
  if (usage === "DECLINED") return asyncRequestStatus === "REJECTED"
  return false
}
